import {IEntity} from "../../../../typescript-plugin/entities/IEntity";
import {Reservation} from "./Reservation";
import {Key} from "../../../../typescript-plugin/entities/Key";
import {Slot} from "./Slot";
import {IdKey} from "../../../../typescript-plugin/entities/IdKey";

export class UserReservation implements IEntity{

    public id:string;
    public email:string;
    public firstname:string;
    public lastname:string;
    public phone:string;
    public reservations:Array<Reservation>;
    public vanId:string;
    public latestDate:Date;
    public validated:boolean;
    public comment:string;

    public Key(): Key {
        return new IdKey(this.id);
    }

    constructor(){
        this.reservations = [];
        this.validated = false;
    }

    public ComputeLatestDate(){
        let latestDate:number = 0;
        for(let reservation of this.reservations){
            if(reservation.slot.Date().getTime() > latestDate){
                latestDate = reservation.slot.Date().getTime();
            }
        }
        this.latestDate = new Date(latestDate);
    }

    public AddUserReservationIdToReservations(){
        for(let reservation of this.reservations){
            reservation.userReservationId = this.id;
        }
    }
    public AddCalendarId(calendarId:string){
        for(let reservation of this.reservations){
            reservation.calendarId = calendarId;
        }
    }

    public Serialize(): {} {
        let data = this.ToPersistable();
        data['Items'] = this.SerializeReservations();
        return data;
    }

    public Deserialize(data: {}): void {
        this.ToEntity(data);
        this.DeserializeReservations(data);
    }

    public ToPersistable(): {} {
        return {
            id: this.id,
            email: this.email,
            firstname: this.firstname,
            lastname: this.lastname,
            phone: this.phone,
            comment: this.comment,
            latestDate: this.latestDate == undefined ? undefined : this.latestDate.getTime(),
            vanId: this.vanId,
            validated: this.validated
        };
    }

    public ToEntity(data: {}): void {
        this.id = data['id'];
        this.email = data['email'];
        this.firstname = data['firstname'];
        this.lastname = data['lastname'];
        this.phone = data['phone'];
        this.comment = data['comment'];
        this.latestDate = new Date(data['latestDate']);
        this.vanId = data['vanId'];
        this.validated = data['validated'];
    }

    public Slots():Array<Slot>{
        let slots:Array<Slot> = [];
        for(let reservation of this.reservations){
            slots.push(reservation.slot);
        }
        return slots;
    }

    public AsFake(email:string='john.smith@gmail.com'):UserReservation{
        this.id = email;
        this.email = email;
        this.firstname = "John";
        this.lastname = "Smith";
        this.phone = "+32 458 55 21 86";
        this.comment = "Bonjour, je souhaiterais venir chercher le véhicule vers 10h ci cela est possible ? " +
            "Concernant le retour, je pense ramener le véhicule vers 18h. Cela dépendra du traffic." +
            "J'aurai également souhaité avoir plus d'information sur le nombre de kilomètres qu'il est possible de faire avec le véhicule";
        this.latestDate = new Date(42);
        this.reservations = [new Reservation().AsFake(), new Reservation().AsFake()];
        this.reservations[0].slot = new Slot("2018-10-3-AM");
        this.reservations[1].slot = new Slot("2018-10-3-PM");
        this.reservations[0].userReservationId = "id";
        this.reservations[1].userReservationId = "id";
        this.vanId = "vanId";
        this.validated = false;
        return this;
    }

    private SerializeReservations():any{
        let reservationsSerialized:Array<{}> = [];
        for(let reservation of this.reservations){
            reservationsSerialized.push(reservation.Serialize());
        }
        return reservationsSerialized;
    }

    private DeserializeReservations(data:{}):any{
        this.reservations = [];
        for(let serializedReservation of data['Items']){
            let reservation:Reservation = new Reservation();
            reservation.Deserialize(serializedReservation);
            this.reservations.push(reservation);
        }
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/server/src/base/entities/leasing/calendar/UserReservation.ts